/* HGN menu v2: the mobile menu test `menuv2` (20 Oct 2026). Runbook: redesigned/_golive-2026-10-menu-v2/PASTE.md.
   Loaded async by snippets/hgn-menu-v2.liquid, which prints nothing at all while Theme settings → Menu v2 is Off.

   1. Arm: the shared registry (assets/hgn-side-cart-attach.js): registerArm('menuv2', 'menuV2Arm', {pctB 50, qa 'hgn_menuv2'}).
      Sticky per browser (localStorage hgn_arm_menuv2), html[data-hgn-arm-menuv2], cart attribute _hgn_arm_menuv2 (orders),
      Clarity tag hgn_arm_menuv2. Setting: split | 90 | A | B. Theme editor: a preview of B, never logged.
   2. Rows, in BOTH arms, posted straight to the popup worker's POST /api/exp/event (D1 hgn_popup.exp_events, family menuv2),
      exactly as snippets/hgn-arm-beacon.liquid posts its families (same body, did = localStorage hgn:did, text/plain
      sendBeacon, one row per session per key; the worker keeps one per day). That file is NOT edited: the worker takes any
      family name, and order rows come from the cart attribute through the worker's order webhook, as for every family.
        assigned   the browser has an arm (once a session)
        shown      the menu was OPENED at a mobile width (the exposure, the denominator)
        accepted   a link or search tapped inside it; reason = best|all|range|howto|kits|season|viewed|page|account|search, tier = range or season
        atc        an add to cart on any later page view, once this browser has opened the menu
        kit_start  kit build mode switched on, same condition
   3. Arm B only: the drawer's content is replaced by the snippet's <template> (cloned on the first open; images load then),
      styled by assets/hgn-menu-v2.css, which loads after the page's load event (or on the first tap, if sooner). Until that
      CSS has loaded the shopper sees today's menu, never an unstyled one. Desktop widths always keep today's drawer.
   Arm A: today's drawer, untouched. Nothing here edits the header's own open / close / search code. */
(function () {
  'use strict';
  var W = window, D = document, H = D.documentElement;
  if (W.__hgnMenu2) return;
  var tpl = D.querySelector('template[data-hgn-menu2-tpl]');
  if (!tpl || !tpl.closest) return;
  var panel = tpl.closest('.hgn-header__mobile-panel');
  var header = tpl.closest('.hgn-header');
  var trigger = header && header.querySelector('.hgn-header__menu-trigger');
  if (!panel || !trigger) return;
  W.__hgnMenu2 = 1;

  var MODE = tpl.getAttribute('data-mode') || 'off';
  var DESIGN = tpl.getAttribute('data-design') === '1';
  var CSS = tpl.getAttribute('data-css') || '';
  var CID = tpl.getAttribute('data-customer') || 'anon';
  var MQ = W.matchMedia ? W.matchMedia('(max-width: 900px)') : null;
  function mobile() { return !MQ || MQ.matches; }
  function registry() { var hg = W.HGN; return !!(hg && typeof hg.registerArm === 'function' && typeof hg.armFor === 'function'); }

  /* The registry loads before the header today (a sync script in theme.liquid). If a later speed change defers it, wait
     for it (DOMContentLoaded, then load) rather than give up: until then the menu is today's and nothing is logged. */
  if (DESIGN || MODE === 'off' || registry()) boot();
  else {
    var later = function () { if (registry()) { boot(); return true; } return false; };
    var onLoad = function () { later(); };
    var onReady = function () { if (!later() && D.readyState !== 'complete') W.addEventListener('load', onLoad, { once: true }); };
    if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', onReady, { once: true });
    else if (D.readyState === 'interactive') onReady();
    else onLoad();
  }

  function boot() {
    /* ── 1. the arm ── */
    function decide() {
      if (DESIGN) return MODE === 'A' ? 'A' : 'B';
      if (MODE === 'off' || !registry()) return null;
      try {
        var cfg = W.HGN_SIDE_CART_CONFIG = W.HGN_SIDE_CART_CONFIG || {};
        cfg.attach = cfg.attach || {};
        cfg.attach.menuV2Arm = MODE;
        W.HGN.registerArm('menuv2', 'menuV2Arm', { pctB: 50, qa: 'hgn_menuv2' });
        var a = W.HGN.armFor('menuv2');
        if (a !== 'A' && a !== 'B') return null;
        H.setAttribute('data-hgn-arm-menuv2', a);
        return a;
      } catch (e) { return null; }
    }
    var ARM = decide();
    if (!ARM) return;

    /* ── 2. rows (the arm beacon's transport and body, family menuv2) ── */
    var EP = 'https://popup.holygrailnail.co/api/exp/event', SENT = 'hgn_menuv2_sent', sent = {}, cartToken = '';
    var EVENT = { assigned: 'assigned', open: 'shown', tap: 'accepted', atc: 'atc', kit: 'kit_start' };
    try { (JSON.parse(sessionStorage.getItem(SENT) || '[]') || []).forEach(function (k) { sent[k] = 1; }); } catch (e) {}
    function analyticsAllowed() {
      try { var cp = W.Shopify && W.Shopify.customerPrivacy; if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false; } catch (e) {}
      return true;
    }
    function deviceId() {
      var d = '';
      try { d = localStorage.getItem('hgn:did') || ''; } catch (e) {}
      if (!d && analyticsAllowed()) {
        try { d = W.crypto && crypto.randomUUID ? crypto.randomUUID() : ''; } catch (e) {}
        if (!d) d = 'd-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        try { localStorage.setItem('hgn:did', d); } catch (e) {}
      }
      if (!d && W.HGN_CUSTOMER_ID) d = 'cust-' + String(W.HGN_CUSTOMER_ID);
      return d;
    }
    function token(v) { return String(v || '').replace(/[^a-z0-9_-]/gi, '').slice(0, 40).toLowerCase(); }
    function fire(name, detail) {
      if (DESIGN) return;
      try {
        detail = detail || {};
        var ev = EVENT[name], did = deviceId();
        if (!ev || !did) return;
        var tier = token(detail.tier), reason = token(detail.reason), surf = token(detail.surface);
        var key = ['menuv2', ARM, ev, tier, reason, surf].join('|');
        if (sent[key]) return;
        sent[key] = 1;
        try { sessionStorage.setItem(SENT, JSON.stringify(Object.keys(sent).slice(-60))); } catch (e) {}
        var body = JSON.stringify({ did: did, family: 'menuv2', arm: ARM, event: ev, tier: tier, reason: reason, surface: surf, cartToken: cartToken, page: location.pathname });
        var ok = false;
        try { if (navigator.sendBeacon) ok = navigator.sendBeacon(EP, new Blob([body], { type: 'text/plain' })); } catch (e) {}
        if (!ok) { try { fetch(EP, { method: 'POST', body: body, keepalive: true, mode: 'cors' })['catch'](function () {}); } catch (e) {} }
      } catch (e) {}
    }
    D.addEventListener('hgn:cart:change', function (e) {
      try { var c = e && e.detail && e.detail.cart; if (c && c.token) cartToken = String(c.token).split('?')[0]; } catch (err) {}
    });
    var SEEN = 'hgn_menuv2_seen', seenMem = false;
    function seen() { if (seenMem) return true; try { return !!localStorage.getItem(SEEN); } catch (e) { return false; } }
    function markSeen() {
      seenMem = true;
      try { if (!localStorage.getItem(SEEN)) localStorage.setItem(SEEN, String(Date.now())); } catch (e) {}
    }
    function low(h) { return String(h || '').toLowerCase(); }
    function tierOf(h) {
      h = low(h);
      if (h.indexOf('/collections/') === -1 || h.indexOf('pedicure') !== -1) return '';
      return /press-on/.test(h) ? 'press-ons' : /gel-nail|semi-cured|\/gels/.test(h) ? 'gels' : /holy-classics|non-uv|classic/.test(h) ? 'classic' : '';
    }
    function kindOf(a) {
      var k = a.getAttribute('data-hgn-menu2-kind');
      if (k) return k;
      var h = low(a.getAttribute('href'));
      if (a.closest('.hgn-header__mobile-foot')) return 'account';
      if (a.closest('[data-hgn-viewed]')) return 'viewed';
      if (/\/collections\/all/.test(h)) return 'all';
      if (/\/collections\/top-sellers/.test(h)) return 'best';
      if (/starter-kit/.test(h)) return 'kits';
      if (/\/collections\/(halloween|christmas)/.test(h)) return 'season';
      if (/\/pages\/[^?#]*(application|how-to)/.test(h)) return 'howto';
      return tierOf(h) ? 'range' : 'page';
    }
    function surface() { return panel.classList.contains('hgn-menu2-on') ? 'v2' : 'v1'; }
    function el(e) { var t = e && e.target; return t && t.closest ? t : t && t.parentElement; }

    D.addEventListener('click', function (e) {
      var t = el(e);
      if (!t) return;
      if (t.closest('.hgn-header__menu-trigger') === trigger) { opened(); return; }
      if (!mobile() || !panel.contains(t)) return;
      if (t.closest('[data-hgn-search-toggle],[data-hgn-menu2-search]')) { fire('tap', { reason: 'search', surface: surface() }); return; }
      var a = t.closest('a[href]');
      if (!a) return;
      var tier = a.getAttribute('data-tier') || tierOf(a.getAttribute('href'));
      fire('tap', { reason: kindOf(a), tier: tier, surface: surface() });
    }, true);

    var lastAdd = 0;
    function added() {
      if (!seen()) return;
      var t = Date.now();
      if (t - lastAdd < 3000) return;
      lastAdd = t;
      fire('atc', {});
    }
    D.addEventListener('hgn:side-cart:add', added);
    D.addEventListener('cart:update', added);
    D.addEventListener('hgn:kit-build-mode:change', function (e) {
      var d = (e && e.detail) || {};
      if (seen() && d.to === 'on' && d.from !== 'on') fire('kit', {});
    });

    fire('assigned', {});

    function opened() {
      if (!mobile()) { panel.classList.remove('hgn-menu2-on'); return; }
      markSeen();
      fire('open', { surface: 'header' });
      if (ARM === 'B') show(true);
    }
    if (ARM !== 'B') return;

    /* ── 3. arm B: the v2 drawer ── */
    var root = null, cssState = 0, cbs = [];
    function loadCss(cb) {
      if (cssState === 2) { if (cb) cb(); return; }
      if (cb) cbs.push(cb);
      if (cssState === 1 || !CSS) return;
      cssState = 1;
      var l = D.createElement('link');
      l.rel = 'stylesheet';
      l.href = CSS;
      l.onload = function () { cssState = 2; var q = cbs; cbs = []; q.forEach(function (f) { try { f(); } catch (e) {} }); };
      l.onerror = function () { cssState = 0; cbs = []; };
      (D.head || H).appendChild(l);
    }
    function build() {
      if (root) return root;
      var frag = tpl.content && tpl.content.cloneNode(true);
      var nav = frag && frag.querySelector('[data-hgn-menu2]');
      if (!nav) return null;
      var head = panel.querySelector('.hgn-header__mobile-head');
      panel.insertBefore(frag, head ? head.nextSibling : panel.firstChild);
      root = nav;
      var sb = root.querySelector('[data-hgn-menu2-search]');
      if (sb) sb.addEventListener('click', function (e) {
        e.preventDefault();
        /* the header's own search (strip, suggestions, focus): its drawer button is still in the DOM, just hidden */
        var orig = panel.querySelector('[data-hgn-search-toggle]') || D.querySelector('[data-hgn-search-toggle]');
        if (orig) orig.click();
      });
      return root;
    }
    function inHidden(n) { for (; n && n !== root; n = n.parentElement) if (n.hidden) return true; return false; }
    function images() {
      var list = root.querySelectorAll('img[data-src]');
      for (var i = 0; i < list.length; i++) {
        var im = list[i];
        if (inHidden(im)) continue;
        im.decoding = 'async';
        im.setAttribute('src', im.getAttribute('data-src'));
        im.removeAttribute('data-src');
      }
    }
    /* one seasonal tile: the first whose order-by day has not ended (Liquid printed only seasons alive at render time;
       this re-checks the real clock, because Shopify can serve a page rendered hours ago) */
    function season() {
      var rows = root.querySelectorAll('[data-hgn-menu2-season]'), now = Date.now() / 1000, on = false;
      for (var i = 0; i < rows.length; i++) {
        var u = parseInt(rows[i].getAttribute('data-until'), 10);
        var ok = !on && u > now;
        rows[i].hidden = !ok;
        if (ok) on = true;
      }
    }
    function isKit(it) {
      var h = low(it.handle), t = low(it.title);
      return h.indexOf('starter-kit') !== -1 || h.indexOf('starter_kit') !== -1 || t.indexOf('starter kit') !== -1 || String(it.type || '') === 'Starter Kits';
    }
    /* Recently viewed: the header's own list (snippets/hgn-header-viewed.liquid, localStorage hgn-viewed:<customer|anon>),
       newest 4 as thumbnails; the row is absent when the list is empty. */
    function viewed() {
      var box = root.querySelector('[data-hgn-menu2-viewed]');
      var list = box && box.querySelector('[data-hgn-menu2-viewed-list]');
      if (!list) return;
      var items = [];
      try { items = JSON.parse(localStorage.getItem('hgn-viewed:' + CID) || '[]') || []; } catch (e) { items = []; }
      if (!Array.isArray(items)) items = [];
      items = items.filter(function (it) { return it && it.url && !isKit(it); }).slice(0, 4);
      list.textContent = '';
      items.forEach(function (it) {
        var li = D.createElement('li'), a = D.createElement('a');
        a.href = it.url;
        a.className = 'hgn-menu2__viewed-item';
        a.setAttribute('data-hgn-menu2-kind', 'viewed');
        a.setAttribute('aria-label', String(it.title || 'Viewed product'));
        if (it.image) {
          var im = D.createElement('img');
          im.alt = '';
          im.width = 56;
          im.height = 56;
          im.decoding = 'async';
          im.src = it.image;
          a.appendChild(im);
        }
        li.appendChild(a);
        list.appendChild(li);
      });
      box.hidden = !items.length;
    }
    function show(open) {
      loadCss(function () {
        if (!build()) return;
        season();
        viewed();
        images();
        if (open && mobile()) panel.classList.add('hgn-menu2-on');
      });
    }
    /* finger down on the menu button: start the CSS and the images ~100 ms before the click opens the drawer */
    D.addEventListener('pointerdown', function (e) {
      var t = el(e);
      if (t && t.closest('.hgn-header__menu-trigger') === trigger && mobile()) show(false);
    }, { capture: true, passive: true });
    /* the CSS (~6 KB, cached after) once the page has loaded and gone idle, so the first open is styled at once */
    function idle() { (W.requestIdleCallback || function (f) { return setTimeout(f, 300); })(function () { loadCss(); }, { timeout: 4000 }); }
    if (D.readyState === 'complete') idle(); else W.addEventListener('load', idle, { once: true });
  }
})();
